import { isCNDomain } from "@/utils/utils";

export default function ShowOrHideInCNAreaController(UIExtension) {
  UIExtension.modular.module('phantom').controller('ShowOrHideInCNAreaController', {
    // The controller is registered only after the file is opened.
    mounted() {
      const attrs = this.component.attrs;
      if (isCNDomain()) {
        if (attrs['show'] === 'CN') {
          this.component.show();
        } else {
          this.component.hide();
        }
      } else {
        if (attrs['show'] === 'CN') {
          this.component.hide();
        } else {
          this.component.show();
        }
      }
    }
  })
}